import { Inject, Injectable, Optional } from '@angular/core';
import { FhirApiService } from '../../../services/api/fhir-api.sevice';
import { DataFhirService } from '../../data-fhir.service';
import { UserService } from '../../../services/user.service';
import {
  QuestionnaireResponseEntry,
  QuestionnaireResponseEntryAdapter,
} from './questionnaire-response.model';
import { HttpParamsObject } from '../../../services/api/api.service';
import { ReducerManager, Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class QuestionnaireResponseService extends DataFhirService<QuestionnaireResponseEntry> {
  protected readonly defaultParamsObject: HttpParamsObject = {};

  constructor(
    @Inject('dataName') @Optional() dataName: string,
    protected adapter: QuestionnaireResponseEntryAdapter,
    protected fhirApi: FhirApiService,
    protected userService: UserService,
    protected store: Store,
    protected manager: ReducerManager,
  ) {
    super(
      dataName || 'questionnaires-response',
      adapter,
      fhirApi,
      userService,
      store,
      manager,
    );
  }
}
